/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var dateRangePickerProps = {
  allowInput: Boolean,
  clearable: Boolean,
  disableDate: {
    type: [Object, Array, Function]
  },
  disabled: Boolean,
  enableTimePicker: Boolean,
  firstDayOfWeek: {
    type: Number,
    validator: function validator(val) {
      if (!val) return true;
      return [1, 2, 3, 4, 5, 6, 7].includes(val);
    }
  },
  format: {
    type: String,
    "default": ""
  },
  mode: {
    type: String,
    "default": "date",
    validator: function validator(val) {
      if (!val) return true;
      return ["year", "quarter", "month", "week", "date"].includes(val);
    }
  },
  panelPreselection: {
    type: Boolean,
    "default": true
  },
  placeholder: {
    type: [String, Array]
  },
  popupProps: {
    type: Object
  },
  prefixIcon: {
    type: Function
  },
  presets: {
    type: Object
  },
  presetsPlacement: {
    type: String,
    "default": "bottom",
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "top", "right", "bottom"].includes(val);
    }
  },
  rangeInputProps: {
    type: Object
  },
  separator: {
    type: String,
    "default": ""
  },
  status: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "success", "warning", "error"].includes(val);
    }
  },
  suffixIcon: {
    type: Function
  },
  timePickerProps: {
    type: Object
  },
  tips: {
    type: [String, Function]
  },
  value: {
    type: Array,
    "default": void 0
  },
  defaultValue: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  valueType: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["time-stamp", "Date", "YYYY", "YYYY-MM", "YYYY-MM-DD", "YYYY-MM-DD HH", "YYYY-MM-DD HH:mm", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm:ss:SSS"].includes(val);
    }
  },
  onBlur: Function,
  onChange: Function,
  onFocus: Function,
  onInput: Function,
  onPick: Function
};

export { dateRangePickerProps as default };
//# sourceMappingURL=date-range-picker-props.js.map
